module.exports = __webpack_public_path__ + "static/media/slack.058bf664.svg";